 
CheckoutV2.Payment = function(checkout, pay, isReview, review_totals) {
	var payment = this;
	var prefix = '';
	var reviewPrefix = 'review-';
	isReview = isReview || false;
	if (isReview) 
		prefix = reviewPrefix;

	this.saved = true;

	this.summary = false;
	this.totals = false;

	this.methods = {};
	this.balanceMethods = [];
	this.methodRequired = true;

	this.cart_totals = checkout.cart.totals;
	if (isReview) 
		this.cart_totals = review_totals;

	this.optionToMethod = {
		'creditcard': CheckoutV2.Payment.CreditCard,
		'storedcreditcard': CheckoutV2.Payment.StoredCreditCard,
		'paypal': CheckoutV2.Payment.PayPal,
		'wiretransfer': CheckoutV2.Payment.WireTransfer,
		'priorauth': CheckoutV2.Payment.PriorAuth,
		'paypalrequest': CheckoutV2.Payment.PayPalRequest,
		'onaccount': CheckoutV2.Payment.OnAccount
	};

	this.$wrap = $('#paymentoptionswrapper'); // not available
	this.$anchor = $('a[name=payment]'); // not available
	this.$error = $('#' + prefix + 'payment-error'); // not available
	this.$errorMsg = this.$error.find('.msg-text');
	this.$errorClose = this.$error.find('.close');
	this.$loadingOverlay = $('#payment-loading-overlay');
	this.$loadingMsg = this.$loadingOverlay.find('.msg-text');

	this.$cShopping = this.$wrap.find('.cshopping'); // unavailable
	this.$showEmailCart = this.$wrap.find('#showEmailCart'); 
	this.$methodWrap = $('#payment-selector');
	this.$methodError = $('#' + prefix + 'payment-method-error');
	this.$methodErrorMsg = this.$methodError.find('.msg-text');
	this.$methodSelect = $('input[type="radio"][name="' + prefix + 'payment-method"]');
	this.$methodSelectWrap = $('#' + prefix + 'payment-method-select-wrap');
	this.$methodSelectDisabled = $('#' + prefix + 'payment-method-select-disabled');
	this.$methodSelectAdd = $('#payment-method-add-another select');
	this.$methodContainer = $('.' + prefix + 'payment-methods'); // available
	this.creditCardWrap = false;
	this.initMethod = '';
	this.selectedMethod = '';
	this.selectedContainer = '';
	this.$modal = $('#changePaymentModal');
	this.$changePayment = $('#useThisPaymentMethod');
	this.$noPaymentMethod = $('.js-no-payment-method:not(.js-review)');
	this.$noPaymentMethodMsg = this.$noPaymentMethod.find('.js-no-payment-method-msg');
	this.$paymentMethod = $('.js-payment-method:not(.js-review)');
	this.$reviewPaymentMethod = $('.js-review.js-payment-method-toggle');

	this.init = function() {
		payment.listen();

		//payment.summary = new Checkout.Payment.Summary(checkout, payment);
		//payment.totals = new Checkout.Payment.Totals(checkout, payment);

		payment.balanceMethods.push(new CheckoutV2.Payment.InStore(checkout, payment, isReview));
		payment.balanceMethods.push(new CheckoutV2.Payment.Rewards(checkout, payment, isReview));
		payment.balanceMethods.push(new CheckoutV2.Payment.GiftCard(checkout, payment, isReview));

		//if (checkout.config.paypalError) {
		//	payment.error(checkout.paypalErrorMsg);
		//	checkout.config.paypalError = 0;
		//}
		
		payment.buildContent();
                
		if (isReview) {
			payment.buildMethods();
			$('input[type="radio"][name="review-payment-method"][value="'+pay.selectedContainer+'"]').prop('checked', true)
			payment.setSelectedMethod(pay.selectedContainer);
			payment.changeMethod(false);
		} else {
			$('input[type="radio"][name="payment-method"][value="creditcard"]').prop('checked', true);
			payment.setSelectedMethod('creditcard');
			payment.changeMethod(true);
		}
    };

	this.setSelectedMethod = function(value) {
		payment.selectedContainer = value;
		
		if (value == 'creditcard') {
			if (checkout.session.get('storedPayments').length) {
				payment.selectedMethod = checkout.session.get('storedPayments')[0].method;
			} else { 
				payment.selectedMethod = value;
			}
		} else {
			payment.selectedMethod = value;
		}

		payment.setButtonText(value);
	};
	
	this.setButtonText = function(value) {
		if (isReview) {
			if (value == 'paypal' && checkout.payment.selectedMethod != 'paypal') {
				$('.js-choose-payment-method').html('Proceed to Paypal');
			} else {
				$('.js-choose-payment-method').html('Use This Payment');
			}
		} else {
			if (value == 'paypal') {
				$('.js-next-step').html('Proceed to Paypal <i class="fa fa-arrow-right"></i>');
			} else {
				if (checkout.currentStepName() == 'review') {
					$('.js-next-step').html('Place Order');
				} else {
					$('.js-next-step').html('Review Order <i class="fa fa-arrow-right"></i>');
				}
			}
		}
	};

	this.unlisten = function() {  
		payment.$methodSelect.off('change');
		payment.$methodContainer.off('click','.'+prefix+'payment-method-remove');
        payment.$methodContainer.off('input propertychange', '.' + prefix + 'payment-method-amount input');
		payment.$methodContainer.off('change', '.' + prefix +'payment-method-amount input');
		$('.payment-method input, .' + prefix +'payment-method select, #' + prefix + 'payment-method-select').off('focus');
		checkout.cart.$wrap.off('loading.payment');
		checkout.cart.$wrap.off('loadDone.payment');
		checkout.cart.$wrap.off('loadFail.payment');
		$('.js-' + prefix + 'split-payment').off('click');
		$('.js-add-credit-card-btn').off('click');
		payment.$errorClose.off('click');
		if (payment.$modal) {
			payment.$modal.off('show.bs.modal');	
			payment.$modal.off('hide.bs.modal');	
		}
		if (payment.$changePayment)  {
			payment.$changePayment.off('click');	
		}
	
		
	};

	this.listen = function() {

		payment.unlisten();
		payment.$methodSelect.change(function() {
			payment.setSelectedMethod(this.value);
			payment.changeMethod(true);
		});
		
		// delegated events for selectors on methods
		
		payment.$methodContainer.on('click', '.payment-method-remove', function() {
			payment.removeMethod(false, $(this), true);
			payment.setMethodSessionData();
		});
		
		payment.$methodContainer.on('input propertychange', '.payment-method-amount input', function(e) {
			payment.changeMethodAmt($(this), false);
		});
		
		payment.$methodContainer.on('change', '.payment-method-amount input', function(e) {
			payment.changeMethodAmt($(this), !isReview);
		});
		
		payment.$methodContainer.on('keyup', '.js-card-amount', function(e) {
			checkout.restrictFloats(e);
		});
		
		//payment.$methodContainer.on('focus blur', '.js-card-amount', function(e){
		//	console.log('focus blur', e, $(this));
		//	if (e.type == 'focusin') {
		//		$(this).attr('type', 'number');
		//	} else if (e.type == 'focusout') {
		//		$(this).attr('type', 'text');
		//	}
		//});

		$('.payment-method input, .' + prefix +'payment-method select, #' + prefix + 'payment-method-select').focus(function() {
			payment.removeFieldError($(this));
		});

		// listen for cart content changes
		checkout.cart.$wrap.on('loading.payment', function(e, loadingMsg) {
			payment.loading(loadingMsg);
		});

		checkout.cart.$wrap.on('loadDone.payment', function(e, stepChanged) {

			payment.loading(false);

			if (
				checkout.currentStepName() == 'billship'
				|| checkout.currentStepName() == 'payment'
			) {

				if (stepChanged == 'cart')
					payment.summary.buildContent();

				payment.totals.buildContent();

			}

			payment.toggleMethodRequired();

			payment.reApplyBalances();

		});


		checkout.cart.$wrap.on('loadFail.payment', function() {
			payment.hide();
		});
		
		$('.js-' + prefix + 'split-payment').on('click', function(){
			var inlineCreditCard = payment.isInlineCreditCard();
			if (inlineCreditCard.shown) { // need to validate credit card form (no stored cards) before split window
				var dataCheck = inlineCreditCard.method.validate();
				if (!dataCheck.valid) {
					return;
				} else { // save updated billinfo before split
					// TODO: can we attach this to change address?
					inlineCreditCard.method.setBillInfoData(checkout.billinfo.getData().billing);
				}
			}
			
			var cardList = [];
			var cardsInUse = [];
			
			$.each(payment.getData(true), function(i, pmnt) {
				if (pmnt.storedPaymentID) {
					cardsInUse.push(pmnt.storedPaymentID);
				}
			});
			
			$.each(checkout.session.get('storedPayments'), function(i, card) {
				var cardID = card.method.split('storedcreditcard-')[1];
				
				if ( $.inArray(cardID, cardsInUse) < 0 ) {
					cardList.push({
						id: cardID,
						type: card.cardType,
						last_four: card.cardLast4,
						expire_month: ((card.expMonth + '').length == 1 ? '0' : '') + card.expMonth,
						expire_year: (card.expYear + '').slice(-2),
						first_name: card.firstName,
						last_name: card.lastName,
						address: card.address,
						city: card.city,
						state: card.state,
						zip: card.zip,
					});
				}
			});
			if (cardList.length) {
				$('#splitPaymentModal .js-credit-card-list').html(
					Jemplate.process('includes/partials/payment/creditCardList.html', {
						current_card: cardList[0].id,
						card_list: cardList,
						list_type: 'split',
					})
				);
				$('#splitPaymentModal .js-has-stored-credit-cards').show();
				$('#splitPaymentModal .js-credit-card-list .card-actions').hide();
				$('#splitPaymentModal .js-no-stored-credit-cards').hide();
				$('#splitPaymentModal .js-split-btn').removeClass('js-add-credit-card-btn').addClass('js-split-credit-card-btn');
				$('#splitPaymentModal .js-split-btn').text('Use This Card');
				
				$('#splitPaymentModal .js-credit-card-list .card-address[data-toggle="popover"]').popover();
				
				$('#splitPaymentModal .js-add-credit-card').off('click');
				$('#splitPaymentModal .js-add-credit-card').on('click', function(){
					$('#addCreditCardModal .credit-card-alert .msg-text').html('');
					$('#addCreditCardModal .credit-card-alert').hide();
					$('#addCreditCardModal').modal('show');
					$('#addCreditCardModal .replaceMethodKey').val('');
				});
			} else {
				$('#splitPaymentModal .js-no-stored-credit-cards').show();
				$('#splitPaymentModal .js-has-stored-credit-cards').hide();
				$('#splitPaymentModal .credit-card-alert .msg-text').html('');
				$('#splitPaymentModal .credit-card-alert').hide();
				$('#splitPaymentModal .js-split-btn').removeClass('js-split-credit-card-btn').addClass('js-add-credit-card-btn');
				$('#splitPaymentModal .js-split-btn').text('Add Card');
				$('#splitPaymentModal .js-add-credit-card-btn').off('click');
				$('#splitPaymentModal .js-add-credit-card-btn').on('click', { modalID: '#splitPaymentModal' }, payment.addCreditCard);
				$('#splitPaymentModal .js-no-stored-credit-cards').find('.js-card-number,.js-expiry-month,.js-expiry-year,.js-security-code').on('keyup', function(e) {
					checkout.restrictNumbers(e);
				});
			}
			
			$('#splitPaymentModal').modal('show');
			
			if (cardList.length) {
				$('#splitPaymentModal .js-split-credit-card-btn').off('click');
				$('#splitPaymentModal .js-split-credit-card-btn').on('click', function(){
					var $selected = $('#splitPaymentModal .js-credit-card-list input[type=radio]:checked');
					if ($selected && $selected.attr('id')) {
						payment.addMethod('storedcreditcard-'+$selected.attr('id'), 0.00, true);
						$('#splitPaymentModal').modal('hide');
					}
				});
			}
		});
		
		$('#addCreditCardModal .js-what-is-this').popover({
            content: $('.js-popover-wrapper').html(),
			html: true,
			trigger: 'focus',
			placement: 'left',
			boundary: 'window',	
			offset: "-30",
			title: payment.creditCardWhatIsThis().title,
			container: $('#addCreditCardModal .what-is-this')[0],
		});
		
		$('#editCreditCardModal .js-what-is-this').popover({
            content: $('.js-popover-wrapper').html(),
			html: true,
			trigger: 'focus',
			placement: 'left',
			boundary: 'window',
			offset: "-30",
			title: payment.creditCardWhatIsThis().title,
			container: $('#editCreditCardModal .what-is-this')[0],
		});
		
		$('#splitPaymentModal .js-what-is-this').popover({
            content: $('.js-popover-wrapper').html(),
			html: true,
			trigger: 'focus',
			placement: 'left',
			boundary: 'window',
			offset: "-30",
			title: payment.creditCardWhatIsThis().title,
			container: $('#splitPaymentModal .what-is-this')[0],
		});
		
		$('#addCreditCardModal .js-credit-card').find('.js-card-number,.js-expiry-month,.js-expiry-year,.js-security-code').on('keyup', function(e) {
			checkout.restrictNumbers(e);
		});
		
		$('.js-add-credit-card-btn').on('click', { modalID: '#addCreditCardModal' }, payment.addCreditCard);
		
		payment.$errorClose.on('click', function(){
			payment.error(false);
		});


		if (payment.$modal) {
			payment.$modal.on('show.bs.modal', function() {
				checkout.review.payment.cloneMethods( checkout.payment );
			});
			payment.$modal.on('hide.bs.modal', function() {
				checkout.review.payment.unlisten();
				checkout.payment.listen();	
			});	
		}
		if (payment.$changePayment)  {
			payment.$changePayment.on('click', function(e) {
				e.preventDefault();
				if (payment.validate()) {
					checkout.payment.cloneMethods( checkout.review.payment );
					checkout.setReview();
					payment.$modal.modal('hide');
				}
			});
		}

	};
	
	this.addCreditCard = function(event) {
		var data = {
			cardType: '',
			cardNum: $(event.data.modalID + ' .js-credit-card .js-card-number').val(),
			expMonth: $(event.data.modalID + ' .js-credit-card .js-expiry-month').val(),
			expYear: $(event.data.modalID + ' .js-credit-card .js-expiry-year').val(),
			cvc: $(event.data.modalID + ' .js-credit-card .js-security-code').val(),
		};
		
		var dataCheck = payment.validateCreditCard(data);
		if (!dataCheck.valid && dataCheck.errorMsg) {
			$(event.data.modalID + ' .credit-card-alert .msg-text').html(dataCheck.errorMsg);
			$(event.data.modalID + ' .credit-card-alert').show();
			return;
		} else {
			$(event.data.modalID + ' .credit-card-alert .msg-text').html('');
			$(event.data.modalID + ' .credit-card-alert').hide();
		}
		
		payment.addMethod('creditcard', 0.00, true, data);
		
		$(event.data.modalID + ' .js-credit-card')[0].reset();
		
		
		if ($('#addCreditCardModal').hasClass('show')) {
			$('#addCreditCardModal').modal('hide');
		}
		
		if ($('#splitPaymentModal').hasClass('show')) {
			$('#splitPaymentModal').modal('hide');
		}
		
		if ($('#changeCreditCardModal').hasClass('show')) {
			var replaceMethodKey = $('#addCreditCardModal .replaceMethodKey').val();
			if (replaceMethodKey) {
				payment.removeMethod(replaceMethodKey, false, true);
			}
			$('#changeCreditCardModal').modal('hide');
		}
	};
	
	this.validateCreditCard = function(data) {
		var rtn = { valid: true, errorMsg: '' };
		
		var intChks = { validCardNum: false, validExpMonth: false, validExpYear: false, validCardType: false };

		for (var field in data) {
			//console.log(field, ' -> ', data[field]);
			if (field == 'storeOnAccount')
				continue;
			
			if (field == 'cardNum') { // Card Number
				if(!data[field]) {
					rtn.errorMsg += "Card Number is required<br/>";
					rtn.valid = false;
				} else {
					intChks.validCardNum = data[field];
				}
			} else if (field == 'expMonth') { // Expiration Month
				if(!data[field]) {
					rtn.errorMsg += "Expiration Month is required<br/>";
					rtn.valid = false;
				} else if (data[field].length != 2 || parseInt(data[field]) < 1 || parseInt(data[field]) > 12) {
					rtn.errorMsg += "Expiration Month is not valid<br/>";
					rtn.valid = false;
				} else {
					intChks.validExpMonth = data[field];
				}
			} else if (field == 'expYear') { // Expiration Year
				if(!data[field]) {
					rtn.errorMsg += "Expiration Year is required<br/>";
					rtn.valid = false;
				} else if (data[field].length != 2 || parseInt(data[field]) < parseInt(new Date().getFullYear().toString().substring(2))) {
					rtn.errorMsg += "Expiration Year is not valid<br/>";
					rtn.valid = false;
				} else {
					intChks.validExpYear = data[field];
				}
			} else if (field == 'cvc') { // Security Code
				if(!data[field]) {
					rtn.errorMsg += "Security Code is required<br/>";
					rtn.valid = false;
				}
			} 
		}
		
		return rtn;
	};
	
	this.creditCardWhatIsThis = function() {
		return {
			title: '',
			content: '<img src="' + CDNpath + '/img/CVV.png" alt="CVV or CVV2" />',
		};
	};
	
	this.isInlineCreditCard = function() {
		var rtn = {shown: false, method: false};
		if (Object.keys(payment.methods).length == 1) {
	        for (var methodKey in payment.methods) {
	            var method = payment.methods[methodKey];
	            if(method.$wrap.attr('data-method') == 'creditcard' && method.isFormView()) {
	                rtn.shown = true;
					rtn.method = method;
	            }
	        }
		}
		return rtn;
	}

	this.buildContent = function(addMethod) {
        /*
		if (checkout.user) {
			var $options = payment.$methodSelectDisabled
				.children()
				.remove();

			if ($options.length) {
				payment.$methodSelect.append($options.clone());
				payment.$methodSelectAdd.append($options.clone());
			}
		}

        var storedPayments = checkout.session.get('storedPayments');

        if (storedPayments.length) {
            var options = $.map(storedPayments, function(storedPayment) {
                var optionValue = storedPayment.method,
                    optionLabel = (
                        creditCardTypes[storedPayment.cardType].label
                        + ' ending in '
                        + storedPayment.cardLast4
                    );

                return '<option value="' + optionValue+'">' + optionLabel + '</option>';
            }).join("\n");

            payment.$methodSelect.find('option[value="creditcard"]')
                .text('Credit Card (New)')
                .before($(options));

            payment.$methodSelectAdd.find('option[value="creditcard"]')
                .text('Credit Card (New)')
                .before($(options));
        }

		payment.summary.buildContent();
		payment.totals.buildContent();
        */
        
		$.each(payment.balanceMethods, function(i, method) {
			if (method.buildContent)
				method.buildContent();
		});
		
        /*
		payment.buildMethods();

		payment.$wrap.show();
        payment.toggleAddMultiDisplayOptions();

		checkout.cart.totals.update('payment');
        */
	};

    this.toggleAddMultiDisplayOptions = function() {

        var $options = payment.$methodSelectAdd.find('option');

        $options.show();

        $.each(payment.methods, function(methodKey, method) {
            if (method.noDisplayCombo && Array.isArray(method.noDisplayCombo) && method.noDisplayCombo.length > 0) {
				method.noDisplayCombo.forEach( function (currentValue, index, array) {
                	$options.filter('[value="' + currentValue + '"]').hide();
                	$options.filter('[value^="' + currentValue + '-"]').hide();
				});
            }
        });

    }

	this.cloneMethods = function( original, updateTotals )  {
		if (!original) 
			return;
		
		updateTotals = (updateTotals !== undefined) ? updateTotals : true;
		
		if (original.methods) {
			var selected = original.selectedContainer;
			original.unlisten();
			if (payment.methods) {
        		for (var methodKey in payment.methods) 
            		payment.removeMethod(methodKey, false, false);
				if (payment.creditCardWrap) 
					payment.creditCardWrap.$container.children().remove();
			}
			var selector = 'payment-method-creditcard-container';
			if (isReview) 
				selector = 'review-' + selector;
		    payment.methods = {};
	        // payment.$methodContainer.empty();
		    payment.creditCardWrap = false;
			// payment.hide();
			// $('.' + selector).children().remove();
			$.each( original.methods, function( method_key, method ) {
				var method_info = original.getMethodData( method );
				var method_amt = method_info.amount;
				method_amt *= 1;
				var method_name = method_info.method;
				var method_data = false;
				if (method.getData) 
					method_data = method.getData();
				var method_billinfo;
				if (method.billInfo)  
					method_billinfo = method.billInfo;

				var new_method = payment.addMethod( method_name, method_amt, updateTotals, method_data, method_billinfo );
				if (new_method['publish']) 
					new_method.publish();
			});
			payment.unlisten(); payment.listen();
            $('input[type="radio"][name="payment-method"][value="' + selected + '"]').prop('checked', true);
            payment.setSelectedMethod(selected);
            // payment.changeMethod(true);
			payment.$methodContainer.show();
        	payment.toggleMethodRequired();
			$('.'+prefix+selected).addClass('show');
			$('.'+prefix+selected).collapse('show');
			

		}
		payment.cart_totals.values = JSON.parse( JSON.stringify( original.cart_totals.values ) );
		$.each( original.balanceMethods, function(idx, bal) {
			var new_bal = payment.balanceMethods[ idx ];
			new_bal.balance = bal.balance;
			new_bal.unlock();
			var sessionData = {};
			sessionData[new_bal.sessionKey] = bal.$checkbox.prop('checked');
			checkout.session.set( sessionData );
			new_bal.buildContent();
			new_bal.removeBalance();
			new_bal.changeUseBalance( true );
		});
		payment.toggleMethodRequired();
		payment.cart_totals.update('payment');

	};


	this.buildMethods = function() {
		
		var methodData = checkout.session.get('paymentMethods');

		if (
			methodData
			&& methodData.length
		) {

			//payment.$methodSelect.val(methodData[0].method);

			$.each(methodData, function(i, data) {
				payment.addMethod(
					data.method,
					(parseFloat(data.amount) || 0),
					false
				);
			});

		} else {

			payment.addMethod(
				payment.selectedMethod,
				(parseFloat(payment.cart_totals.values.remaining) || 0),
				false
			);

		}

	};

	this.hide = function() {
		payment.$wrap.hide();
		payment.methods = {};
		payment.$methodContainer.empty();
		payment.creditCardWrap = false;
	};

	this.getMethodsByType = function(methodType) {
		var methods = [];

		payment.$methodContainer.find('div[data-method='+methodType+']')
			.each(function(i, methodWrap) {
				var methodKey = $(methodWrap).data('methodKey');

				if (payment.methods[methodKey])
					methods.push(payment.methods[methodKey]);
			});

		return methods;
	};

	this.changeMethod = function(updateTotals) {
        
		payment.methodError(false);
        
        // close open accordian card
        $('.' + prefix +'payment-methods .collapse.show').collapse('hide');
        
        for (var methodKey in payment.methods) 
            payment.removeMethod(methodKey, false, false);

		payment.addMethod(
			payment.selectedMethod,
			(parseFloat(payment.cart_totals.values.remaining) || 0),
			false
		);
        
        // open selected accordian card
        $('.' + prefix +'payment-methods .collapse.' + prefix + payment.selectedContainer).collapse('show');

		payment.setMethodSessionData();
        payment.toggleAddMultiDisplayOptions();

		if (updateTotals)
			payment.cart_totals.update('payment');
            
        payment.toggleMethodRequired();
	};

	this.addMethod = function(methodOption, amount, updateTotals, data, billinfo) {
		payment.methodError(false);
		
		data = (data !== undefined) ? data : false; // optional, needed for addCreditCard modal

		if (!methodOption)
			return;

		for (var methodKey in payment.methods)
			if (
				'allowMulti' in payment.methods[methodKey]
				&& !payment.methods[methodKey].allowMulti
			)
				return payment.methodError(payment.methods[methodKey].multiError);

        var methodOptionParts = methodOption.split('-');

        var methodValue = methodOptionParts[0];
        var storedPaymentID = methodOptionParts[1];
        var storedPayment;

        if (storedPaymentID) {
            $.each(checkout.session.get('storedPayments'), function(i, otherStoredPayment) {
                if (methodOption == otherStoredPayment.method) {
                    storedPayment = otherStoredPayment;
                }
            });
        }

		var method = new payment.optionToMethod[methodValue](checkout, payment, storedPayment, isReview),
			methodKey = (new Date()).getTime(),
			$container = payment.$methodContainer;
            
		if (method.addError)
			return payment.methodError(method.addError);

		if (method.getContainer)
			$container = method.getContainer();

		method.$wrap.data('methodKey', methodKey);
		method.$amtInput = (method.$amtInput || method.$wrap.find('.payment-method-amount input'));

		if (!method.$amtInput.attr('disabled'))
			payment.setMethodAmt(method, amount);

		payment.methods[methodKey] = method;
		
		if (data && method.setData) {
			method.setData(data);
		}
		
		if (method.setBillInfoData && !billinfo) { // stamp billinfo record into payment
			method.setBillInfoData(checkout.billinfo.getData().billing);
		}
		if (method.setBillInfoData && billinfo) { // stamp billinfo record into payment
			method.setBillInfoData(billinfo);
		}

		if ($container.find('.payment-method').length > 0 && payment.selectedContainer != 'creditcard') {
			$container.find('.payment-method').replaceWith(method.$wrap).show();
			$container.find('.payment-method').show();
		} else
			$container.append( method.$wrap );

		
		if (method.afterShow) {
			method.afterShow();
		}

		if (Object.keys(payment.methods).length > 1) {
			//payment.$methodSelectWrap.hide();
			payment.removeFieldError(payment.$methodSelect);
			payment.$methodContainer.find('.payment-method-amount, .payment-method-label').show();            
            payment.$methodContainer.find('.' + prefix + 'payment-method-creditcard-wrap').addClass('split-payment');
            
            for (var methodKey in payment.methods) {
                var method = payment.methods[methodKey];
                if(method.setCompactView) {
                    method.setCompactView();
                }
            }
		}

        payment.toggleAddMultiDisplayOptions();

		if (updateTotals)
			payment.cart_totals.update('payment');
		return method;
	};

	this.removeMethod = function(methodKey, $button, updateTotals) {
		methodKey = methodKey || $button.parents('.payment-method').first().data('methodKey');

		var method = payment.methods[methodKey];

		delete(payment.methods[methodKey]);

		method.$wrap.remove();

		if (method.afterRemoved && (!(isReview) || checkout.currentStepName() == 'review') ) { 
			method.afterRemoved();
		}

		var methodKeys = Object.keys(payment.methods);

		if (methodKeys.length <= 1) {

			if (methodKeys.length == 1) {

                var remainingMethod = payment.methods[methodKeys[0]],
                selectMethodValue = remainingMethod.$wrap.attr('data-method');

                if (remainingMethod.getStoredPaymentID) {
                    selectMethodValue += ('-' + remainingMethod.getStoredPaymentID());
                }
				//payment.$methodSelect.val(selectMethodValue);

				payment.setMethodAmt(
					remainingMethod,
					(parseFloat(payment.cart_totals.values.remaining) || 0)
				);

			}

			//payment.$methodSelectWrap.show();

			payment.$methodContainer.find('.' + prefix +'payment-method-amount, .' + prefix +'payment-method-label').hide();            
            payment.$methodContainer.find('.' + prefix +'payment-method-creditcard-wrap').removeClass('split-payment');                    
		}

        payment.toggleAddMultiDisplayOptions();

		if (updateTotals)
			payment.cart_totals.update('payment');
	};

	this.changeMethodAmt = function($input, blurred) {
		var thisMethodKey = $input.parents('.payment-method').first().data('methodKey'),
			thisMethod = payment.methods[thisMethodKey],
			thisMethodAmt = 0.00,
			thisMethodAmtEnabled = true,
			amounts = {},
			methodTotal = 0.00,
			disabledTotal = 0.00,
			remainingBalance = (parseFloat(payment.cart_totals.values.remaining) || 0);

		if (thisMethod.$amtInput.attr('disabled'))
			thisMethodAmtEnabled = false;

		for (var methodKey in payment.methods) {
			var method = payment.methods[methodKey],
				amount = payment.getMethodAmt(method);

			amounts[methodKey] = amount;

			if (method.$amtInput.attr('disabled'))
				disabledTotal += amount;

		}

		for (var methodKey in amounts) {

			if (thisMethodKey == methodKey)
				thisMethodAmt = amounts[methodKey];

			methodTotal += amounts[methodKey];
		}

		if (methodTotal > remainingBalance) {
			var totalReduceAmt = (methodTotal - remainingBalance);

			for (var methodKey in payment.methods) {
				var method = payment.methods[methodKey];

				if (
					thisMethodKey == methodKey
					|| method.$amtInput.attr('disabled')
				)
					continue;

				var newAmount = (amounts[methodKey] - totalReduceAmt);

				if (newAmount <= 0)
					newAmount = 0;

				payment.setMethodAmt(method, newAmount);

				totalReduceAmt -= (amounts[methodKey] - newAmount);

				if (totalReduceAmt <= 0)
					break;
			}
		}

		if (blurred) {

			if (
				thisMethodAmtEnabled
				|| thisMethodAmt > remainingBalance
			) {

				if (!thisMethodAmtEnabled)
					thisMethodAmt = (remainingBalance - (disabledTotal - thisMethodAmt));
				else if (thisMethodAmt > (remainingBalance - disabledTotal))
					thisMethodAmt = (remainingBalance - disabledTotal);

				payment.setMethodAmt(thisMethod, thisMethodAmt);
			}

			payment.setMethodSessionData();
		}

		payment.cart_totals.buildPaymentMethods();
		//payment.totals.buildPaymentMethods();

	};

	this.getMethodAmt = function(method) {
		return parseFloat((parseFloat(method.$amtInput.val()) || 0).toMoney());
	};

	this.setMethodAmt = function(method, amount) {
		var origAmt = payment.getMethodAmt(method);

		if (amount < 0)
			amount = 0.00;

		method.$amtInput.val(amount.toMoney());

		if (
			method.afterChangeAmt
			&& origAmt != amount
		)
			method.afterChangeAmt(amount);
	};

	this.validateMethod = function(method) {
		var valid = true;

		if (payment.getMethodAmt(method) <= 0) {
			payment.fieldError(method.$amtInput, 'Payment Amount Required');
			valid = false;
		}

		if (
            !method.reviewPayment
			&& method.validate
			&& !method.validate(true)
		)
			valid = false;

		return valid;
	};

	this.toggleMethodRequired = function() {
		var remainingBalance = (parseFloat(payment.cart_totals.values.remaining) || 0);
		var remainingBalanceAdj = (parseFloat(payment.cart_totals.values.remaining) || 0);
		var isWireTransfer = false;

		var methodKeys = Object.keys(payment.methods);
		if (methodKeys.length && payment.methods[methodKeys[0]].label == 'Wire Transfer') { // TODO: need better way to map labels
			isWireTransfer = true;
			remainingBalanceAdj -= payment.methods[methodKeys[0]].fee;
		}

		if (remainingBalanceAdj > 0) {
			payment.methodRequired = true;

			if (isWireTransfer) { // add wire transfer fee if needed
				if (! payment.cart_totals.values.fees['Wire Transfer'] ) {
					payment.methods[methodKeys[0]].applyFee();
					remainingBalance += payment.methods[methodKeys[0]].fee;
				}
			}
			
			if (methodKeys.length == 1)
				payment.setMethodAmt(payment.methods[methodKeys[0]], remainingBalance);
			else if (methodKeys.length)
				payment.changeMethodAmt(payment.methods[methodKeys[0]].$amtInput, true);
			
			if ( checkout.currentStepName().match(/payment|review/) ) {
				payment.setButtonText(payment.selectedMethod);
			}

			payment.$methodWrap.show();

			$.each(payment.balanceMethods, function(i, method) {
				method.unlock();
			});

			payment.setMethodSessionData();
			if (!isReview)
				checkout.session.save();
			
			payment.$noPaymentMethod.addClass('js-hide');
			payment.$paymentMethod.removeClass('js-hide');
			if (!isReview && checkout.currentStepName() == 'payment') {
				payment.$noPaymentMethod.hide();
				payment.$paymentMethod.show();
			} 
			payment.$reviewPaymentMethod.show();

		} else {
			payment.methodRequired = false;
			
			// check for wiretansfer and remove fee
			if (isWireTransfer) {
				payment.methods[methodKeys[0]].removeFee();
			}

			payment.$methodWrap.hide();
			payment.$methodWrap.find('input').not('.'+ prefix +'payment-method-amount input').val('');

			$.each(payment.balanceMethods, function(i, method) {
				method.reApplyBalance();
				method.lock();
			});

			payment.setMethodSessionData({
				'paymentMethods': [
					{
						'method': 'balance',
						'amount': '0.00'
					}
				]
			});
			
			payment.$noPaymentMethod.removeClass('js-hide');
			payment.$paymentMethod.addClass('js-hide');
			payment.$noPaymentMethodMsg.text('Your ' + Object.keys(payment.cart_totals.values.balances).join(', ') + ' balance covers the cost of this order.');
			if (!isReview && checkout.currentStepName() == 'payment') {
				payment.$noPaymentMethod.show();
				payment.$paymentMethod.hide();
			}
			payment.$reviewPaymentMethod.hide();
			
			if ( checkout.currentStepName().match(/payment|review/) ) {
				payment.setButtonText('');
			}
		}
	};

	this.changeFees = function(method, fee, updateTotals) {
		var fees = payment.cart_totals.values.fees;

		fee = parseFloat(fee) || 0;

		// No Change
		if ((fees[method.label] || 0) == fee)
			return;

		if (fee)
			fees[method.label] = fee;
		else
			delete(fees[method.label]);

		$.each( payment.balanceMethods, function(idx, meth) {
			if (meth.$checkbox && meth.$checkbox.length && meth.$checkbox.prop('checked')) {
				meth.removeBalance(updateTotals);
				meth.changeUseBalance(updateTotals);
				meth.buildContent();
			}
		});
		// payment.reApplyBalances(updateTotals);

		if (updateTotals)
			payment.cart_totals.update('payment');

	};

	this.changeBalanceMethod = function(method, balance, userEvent) {
		var balances = payment.cart_totals.values.balances;

		balance = parseFloat(balance) || 0;

		// No Change
		if ((balances[method.label] || 0) == balance)
			return;

		if (balance)
			balances[method.label] = balance;
		else
			delete(balances[method.label]);

		if (userEvent) {
			payment.reApplyBalances(true);
		}
		
		payment.toggleMethodRequired(); // re-calc payment method amount
	};

	this.reApplyBalances = function(forceUpdateTotals) {
		var values = payment.cart_totals.values;
		var balances = values.balances;
		var usedBalanceTotal = 0;

		$.each(payment.balanceMethods, function(i, method) {
			method.reApplyBalance();
			usedBalanceTotal += (balances[method.label] || 0);
		});

		// If force update or used balance amount has changed / needs updated
		if (
			forceUpdateTotals
			||
			(
				parseFloat((parseFloat(values.total) - usedBalanceTotal).toMoney()) // calculated remaining balance
				!= parseFloat(parseFloat(values.remaining).toMoney()) // current remaining balance
			)
		) {
			payment.cart_totals.update('payment');
		} else {
			payment.cart_totals.buildPaymentMethods();
			//payment.totals.buildPaymentMethods();
		}
	};

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			payment.$loadingMsg.html(loadingMsg);
			payment.$loadingOverlay.show();
			checkout.alignMiddle(payment.$loadingOverlay.find('.msg'), payment.$loadingOverlay);
		} else
			payment.$loadingOverlay.hide();
	};

	this.getData = function(fullData) {
		var methodData = [];

		if (payment.methodRequired)
			$.each(payment.methods, function(methodKey, method) {
				var arrLen = methodData.push(payment.getMethodData(method, fullData));
				methodData[ arrLen -1 ].methodKey = methodKey;
			});

		return methodData;
	};

	this.getMethodData = function(method, fullData) {
		var data = ((fullData) ? method.getData() : {});

		data.method = method.$wrap.attr('data-method');
		data.amount = payment.getMethodAmt(method).toMoney();

        if (method.getStoredPaymentID)
            data.method += ('-' + method.getStoredPaymentID());

		return data;
	};

	this.setMethodSessionData = function(newMethodData) {
		newMethodData = newMethodData || payment.getMethodSessionData();

		if (payment.methodSessionDataChanged(newMethodData) && !isReview) {

			checkout.session.set({
				'paymentMethods': newMethodData
			});

			payment.saved = false;
		}

        $.each(payment.methods, function(methodKey, method) {
            if (method.reviewPayment) {
                checkout.session.set({ 'requestReviewPayment' : 1 });
                return;
            } 
        });
	};
    
	this.getMethodSessionData = function() {
		var methodData = [];

		for (var methodKey in payment.methods)
			methodData.push(payment.getMethodData(payment.methods[methodKey], false));

		return methodData;
	};

	this.methodSessionDataChanged = function(newMethodData) {
		var methodData = checkout.session.get('paymentMethods'),
			maxLength = newMethodData.length;

		if (!methodData)
			return true;

		if (methodData.length > maxLength)
			maxLength = methodData.length;

		for (var i=0; i<maxLength; i++) {
			var newData = newMethodData[i],
				data = methodData[i];

			if (
				!data
				|| !newData
				|| data.method != newData.method
				|| data.amount != newData.amount
			)
				return true;
		}

		return false;
	};

	this.validate = function() {
		var valid = true,
			methodTotal = 0.00,
			total = (parseFloat(payment.cart_totals.values.total) || 0),
			remainingBalance = (parseFloat(payment.cart_totals.values.remaining) || 0);

		payment.removeErrors();

		if (!payment.methodRequired)
			return true;
		
		var inlineCreditCard = payment.isInlineCreditCard();
		if (inlineCreditCard.shown) { // if inline credit card, update billinfo address before review
			inlineCreditCard.method.setBillInfoData(checkout.billinfo.getData().billing);
		}

		for (var methodKey in payment.methods) {
			var method = payment.methods[methodKey];

			methodTotal += payment.getMethodAmt(method);

			if (!payment.validateMethod(method))
				valid = false;
		}
        
		if (methodTotal.toMoney() != remainingBalance.toMoney()) {            
			payment.methodAmountsInvalid((remainingBalance - methodTotal), (methodTotal - remainingBalance));
			valid = false;
		}

		return valid;
	};

	this.methodAmountsInvalid = function(increaseAmt, decreaseAmt) {
		var total = (parseFloat(payment.cart_totals.total) || 0),
			remainingBalance = (parseFloat(payment.cart_totals.values.remaining) || 0);

		payment.error(
			'Payment Amounts must add up to '
			+ (
				(remainingBalance == total) ?
					'Order Total'
					: 'Remaining Balance'
			)
			+ '. '
			+ (
				(increaseAmt > 0) ?
					'Increase of $' + increaseAmt.toMoney()
					: 'Decrease of $' + decreaseAmt.toMoney()
			)
			+ ' required.'
		);
	};

	this.methodInvalid = function(idx, errorMsg) {
		var method = payment.idxToMethod(idx),
			$field = method.$amtInput;

		if (!method.$amtInput.filter(':visible').length)
			$field = payment.$methodSelect;

		if (method)
			payment.fieldError($field, errorMsg);
	};

	this.methodAmountInvalid = function(idx) {
		var method = payment.idxToMethod(idx);

		if (method)
			payment.fieldError(method.$amtInput, 'Payment Amount Required');
	};

	this.methodFieldErrors = function(idx, fieldErrors) {
		var method = payment.idxToMethod(idx);

		if (
			method
			&& method.fieldErrors
		)
			method.fieldErrors(fieldErrors);
	};

	this.idxToMethod = function(idx) {
		var $wrap = payment.$wrap.find('.' + prefix + 'payment-method:eq('+idx+')');

		if (!$wrap.length)
			return false;

		return payment.methods[$wrap.data('methodKey')];
	};

	this.fieldError = function($field, errorMsg) {
		var enabled = true;

		if ($field.attr('disabled')) {
			enabled = false;
			errorMsg += '<button type="button" class="btn btn-link button-remove"><i class="icon-remove icon-white"></i></button>'
		}

		$field
			.addClass('field-error')
			.tooltip({
				'title': errorMsg,
				'html': true,
				'trigger': 'manual'
			})
			.tooltip('show');

		if (!enabled) {
			var $tip = $field.data('tooltip').$tip;

			$tip.find('.tooltip-inner')
				.css({
					'position': 'relative',
					'padding-right': 35
				});

			$tip.find('.button-remove')
				.css({
					'position': 'absolute',
					'top': 0,
					'right': 0
				})
				.click(function() {
					payment.removeFieldError($field);
				});

		}
	};

	this.removeFieldError = function($field) {
		$field.removeClass('field-error');
	};

	this.removeErrors = function() {
		payment.removeFieldErrors();
		payment.error(false);
	};

	this.removeFieldErrors = function() {
		payment.$wrap.find('input,select,button').removeClass('field-error');
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			var errorMsgHTML = errorMsg.replace(/\n/g, '<br />'),
				currentMsg = payment.$errorMsg.html();

			if (currentMsg)
				payment.$errorMsg.html(currentMsg + '<br />' + errorMsgHTML);
			else
				payment.$errorMsg.html(errorMsgHTML);

			payment.$error.show();

		} else {
			payment.$error.hide();
			payment.$errorMsg.html('');
		}
	}

	this.methodError = function(errorMsg) {
		//if (errorMsg) {
		//	payment.$methodErrorMsg.html(errorMsg);
		//	payment.$methodError.show();
		//} else {
		//	payment.$methodError.hide();
		//	payment.$methodErrorMsg.html('');
		//}
		payment.error(errorMsg);
	};

	this.init();
	return;
};

